import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderInner from "../../utility/HeaderInner";

const WhyUs = () => {
  return (
    <div className="mt-70">
      <HeaderInner title={"Why Coempt"} />
      <div className="container-fluid bg-light py-5">
        {/* Hero Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10 text-center">
            <h1 className="display-4 fw-bold text-black mb-3">
              Why Choose Coempt Edu Teck?
            </h1>
            <p className="lead">
              With over 25 years of dedicated experience in the EdTech sector
            </p>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0">
              <div className="card-body p-5">
                <p className="card-text fs-5">
                  Coempt Edu Teck stands as a premier leader in the EdTech
                  sector, specializing in comprehensive, end-to-end examination
                  solutions for awarding bodies and educational institutions.
                  Our proven track record and extensive portfolio are designed
                  to demonstrate an unmatched commitment to technological
                  excellence, security, scalability, and a deep-seated mission
                  to bridge the digital divide in examinations.
                </p>
                <p className="card-text fs-5">
                  Through our robust, innovative solutions we empower awarding
                  bodies and educational institutions to practice absolute
                  transparency and good governance, impacting key stakeholders
                  be it students, faculty, and education administrators.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Solutions Overview */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <h2 className="text-center mb-4">
              Our Powerful Suite of Integrated Solutions
            </h2>

            {/* OneX */}
            <div className="card mb-4 shadow-sm border-0">
              <div
                className="card-header text-white py-3"
                style={{ backgroundColor: "#0a1530" }}
              >
                <h3 className="h4 mb-0">
                  <i className="fas fa-star me-2"></i>OneX - End-to-End
                  Examination Platform
                </h3>
              </div>
              <div className="card-body">
                <p className="card-text">
                  Our flagship end-to-end platform eliminates the hassles of
                  traditional exams by seamlessly managing pre-examination
                  processes, sophisticated question paper management, AI-powered
                  online proctoring, uncut answer-book digitization, digital
                  evaluation, and post-examination processing.
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Foolproof encryption for data security
                  </li>
                  <li className="list-group-item">
                    Multi-mode delivery support
                  </li>
                  <li className="list-group-item">
                    Advanced analytics for insightful decision-making
                  </li>
                  <li className="list-group-item">
                    Significant cost savings and reduced administrative burdens
                  </li>
                  <li className="list-group-item">
                    Faster results and enhanced productivity
                  </li>
                  <li className="list-group-item">
                    Cloud-based scalability with unparalleled accuracy
                  </li>
                </ul>
              </div>
            </div>

            {/* Onmark */}
            <div className="card mb-4 shadow-sm border-0">
              <div
                className="card-header text-white py-3"
                style={{ backgroundColor: "#0a1530" }}
              >
                <h3 className="h4 mb-0">
                  <i className="fas fa-check-circle me-2"></i>Onmark - Answer
                  Book Scanning & Digital Evaluation
                </h3>
              </div>
              <div className="card-body">
                <p className="card-text">
                  Our Onmark solution redefines answer book scanning and digital
                  evaluation by pioneering the uncut scanning of answer books
                  i.e., without de-threading, thereby maintaining their
                  integrity and ensuring a fraud-proof process.
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Supports distributed, location-independent evaluation
                  </li>
                  <li className="list-group-item">
                    Home-based, centre-based, or blended evaluation options
                  </li>
                  <li className="list-group-item">
                    Intelligent marking interface with customizable rubrics
                  </li>
                  <li className="list-group-item">
                    Robust quality assurance controls (seed scripts, double
                    marking)
                  </li>
                  <li className="list-group-item">
                    Accelerates result generation
                  </li>
                  <li className="list-group-item">
                    Real-time actionable insights through comprehensive
                    analytics
                  </li>
                  <li className="list-group-item">
                    Ensures fairness, efficiency, and seamless integration
                  </li>
                </ul>
              </div>
            </div>

            {/* EzyTest & DigiTAB */}
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="card h-100 shadow-sm border-0">
                  <div
                    className="card-header text-white py-3"
                    style={{ backgroundColor: "#0a1530" }}
                  >
                    <h3 className="h4 mb-0">
                      <i className="fas fa-desktop me-2"></i>EzyTest -
                      Computer-Based Testing
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      EzyTest offers a cutting-edge Computer-Based Testing (CBT)
                      solution that eradicates logistical challenges, AI-driven
                      cheating prevention, and instant results.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="card h-100 shadow-sm border-0">
                  <div
                    className="card-header text-white py-3"
                    style={{ backgroundColor: "#0a1530" }}
                  >
                    <h3 className="h4 mb-0">
                      <i className="fas fa-tablet-alt me-2"></i>DigiTAB -
                      Tablet-Based Paperless Exams
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Our innovative tablet-based paperless examination solution
                      delivers encrypted questions to high-end tablets,
                      providing an authentic writing experience while ensuring
                      zero leaks.
                    </p>
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        Integrated with AI surveillance and biometric
                        authentication
                      </li>
                      <li className="list-group-item">
                        Eco-friendly and cost-effective in the long run
                      </li>
                      <li className="list-group-item">
                        Scalable for any exam size
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Surveillance */}
            <div className="card mb-4 shadow-sm border-0">
              <div className="card-header bg-dark text-white py-3">
                <h3 className="h4 mb-0">
                  <i className="fas fa-video me-2"></i>AI-Based Exam Centre
                  Surveillance
                </h3>
              </div>
              <div className="card-body">
                <p className="card-text">
                  Our AI-based Exam Centre Surveillance solution can be
                  integrated into existing CCTV systems to provide real-time,
                  automated proctoring, suspicious activity detection, and
                  tamper-proof monitoring, drastically reducing human error and
                  operational costs while boosting trust in certification
                  processes.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Digital LABS */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <h2 className="text-center mb-4">Specialized Digital LABS</h2>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="card h-100 shadow-sm border-0">
                  <div
                    className="card-header text-white py-3"
                    style={{ backgroundColor: "#0a1530" }}
                  >
                    <h3 className="h5 mb-0">
                      <i className="fas fa-language me-2"></i>English Lab
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Enhances language proficiency through structured modules,
                      practice tests, and detailed feedback.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card h-100 shadow-sm border-0">
                  <div
                    className="card-header text-white py-3"
                    style={{ backgroundColor: "#0a1530" }}
                  >
                    <h3 className="h5 mb-0">
                      <i className="fas fa-briefcase me-2"></i>Career Lab
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Improves career readiness through comprehensive assessment
                      and development tools.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="card h-100 shadow-sm border-0">
                  <div
                    className="card-header  text-white py-3"
                    style={{ backgroundColor: "#0a1530" }}
                  >
                    <h3 className="h5 mb-0">
                      <i className="fas fa-brain me-2"></i>Aptitude Lab
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Enhances aptitude test performance through targeted
                      practice and skill development.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center mt-3">
              These fully computerized, LAN-based solutions are managed via our
              flexible Teacher Console that allows facilitators to customize
              content, schedule lessons, and monitor student progress
              efficiently.
            </p>
          </div>
        </div>

        {/* Company Commitment */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0 bg-dark text-white">
              <div className="card-body p-5">
                <h2 className="text-center mb-4">
                  Our Commitment to Excellence
                </h2>
                <p className="card-text fs-5">
                  Underpinning our technological offerings is an unwavering
                  commitment to integrity and a user-centric culture. As an ISO
                  and CMMi certified company, we adhere to the highest quality
                  standards in development and delivery.
                </p>
                <p className="card-text fs-5">
                  Our strong techno-commercial team, comprising educators,
                  technologists, and data scientists, continuously innovates and
                  adapts our solutions to evolving trends, diligently
                  integrating Artificial Intelligence and Blockchain to ensure
                  utmost data security and tamper-proof credentials.
                </p>
                <p className="card-text fs-5">
                  Our vision is to revolutionize global examination standards
                  through secure, technology-driven solutions that guarantee
                  every certificate is a true reflection of merit. We invite you
                  to join us in this journey, to leverage our 25 years of
                  excellence, and to experience a partnership dedicated to
                  fairness, efficiency, and trust—making Coempt Edu Teck the
                  unequivocal choice for your examination needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="card shadow-sm border-0">
              <div className="card-body py-5">
                <h2 className="mb-4">
                  Ready to Transform Your Examination Process?
                </h2>
                <p className="lead mb-4">
                  Join hundreds of institutions that trust Coempt Edu Teck for
                  their examination needs
                </p>
                <button className="btn btn-primary btn-lg me-3">
                  Request a Demo
                </button>
                <button className="btn btn-outline-primary btn-lg">
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
